export default "__VITE_ASSET__DYEJTX1E__"